module.exports = __webpack_public_path__ + "static/media/square-1.c8d5dee7.svg";